// extracted by mini-css-extract-plugin
export default {"App-Container":"App_App-Container__e-VBZ","appLoading-Container":"App_appLoading-Container__OwkTE"};